$(function() {

	// carousel big
	// $('.wwf-comp-carousel-big').slick({
	// 	lazyLoad: 'ondemand',
	// 	prevArrow: '<a href="" class="slick-prev"></a>',
	// 	nextArrow: '<a href="" class="slick-next"></a>',
	// 	dots: true
	// });


	// carousel small
	$('.wwf-comp-carousel-small .row').slick({
	  prevArrow: '<a href="" class="slick-prev"></a>',
	  nextArrow: '<a href="" class="slick-next"></a>',
	  appendArrows: $('.wwf-comp-carousel-small'),
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  slide: '.col-md-4',
	  responsive: [
		{
		  breakpoint: 992,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
		  }
		},
		{
		  breakpoint: 768,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	  ]
	});

	// Floating Footer
	$(window).scroll(function(){
		if ( $(this).scrollTop() > ( $('.js-wwf-donation').offset().top) + $('.js-wwf-donation').outerHeight()  ) {
			$('.wwf-floating-footer').fadeIn();
		} else {
			$('.wwf-floating-footer').fadeOut();
		}
	});

	// Back to donation
	$('.js-scroll-to-donation').click(function(e) {
		e.preventDefault();
		$('html,body').animate({
			scrollTop: $('.js-wwf-donation').offset().top - 20
		}, 500);
	});

	// Scroll to the «the new oven» region
	$('.js-scroll-to-new-oven').click(function(e) {
		e.preventDefault();
		$('html,body').animate({
			scrollTop: $('.js-new-oven').offset().top
		}, 500);
	});

	// Edit amount
	$('.wwf-edit-amount').on('click', function(e) {
		e.preventDefault();
		$('.wwf-input').val('').focus();
		dataLayerApi.push({
		    'event': 'analytics-event-tracking',
		    'google-analytics-kategorie': 'Amount Box',
		    'google-analytics-aktion': 'Click Change Amount',
		    'google-analytics-label': window.location.href
		});
	});


	// Google Analytics:
	// Change amount
	$('#donationamount').on('change', function(e) {
		dataLayerApi.push({'event': 'analytics-event-tracking',
				'google-analytics-kategorie': 'Amount Box',
				'google-analytics-aktion': 'Change Amount',
				'google-analytics-label': window.location.href
		});
	});

	// Submit (should this be triggered on click or on submit (if valid)?)
	$('.wwf-donate').on('click', function(e) {
		dataLayerApi.push({'event': 'analytics-event-tracking',
				'google-analytics-kategorie': 'Amount Box',
				'google-analytics-aktion': 'Call to action',
				'google-analytics-label': $('.wwf-input').val()
		});
	});

	// Arrow right
	$('.slick-next').on('click', function(e) {
		dataLayerApi.push({'event': 'analytics-event-tracking',
				'google-analytics-kategorie': 'Action',
				'google-analytics-aktion': 'Arrow',
				'google-analytics-label': 'Right'
		});
	});

	// Arrow left
	$('.slick-prev').on('click', function(e) {
		dataLayerApi.push({'event': 'analytics-event-tracking',
				'google-analytics-kategorie': 'Action',
				'google-analytics-aktion': 'Arrow',
				'google-analytics-label': 'Left'
		});
	});

	// Floatint Footer
	$('.js-scroll-to-donation').on('click', function(e) {
		dataLayerApi.push({'event': 'analytics-event-tracking',
				'google-analytics-kategorie': 'Floating Footer',
				'google-analytics-aktion': 'Click',
				'google-analytics-label':  window.location.href
		});
	});

	//End Google Analytics tracking


	// Handle custom amount input
	$('.wwf-input').keyup(function () {
		// max chars
		// if (this.value.length >= 3) {
		// 	this.value = this.value.substring(0, 3);
		// }
		// Number input only
		this.value = this.value.replace(/[^0-9]/g,'');
	});

	// Client side validation
	var validator = $('#wwfform').validate({
		debug: false,
		onsubmit: true,
		onkeyup: false,
		onfocusout: false,
		ignore: '.ignore',

		rules: {
			donationamount: {
				required: true,
				number: true,
				min: 1,
				max: 5000
			}
		},
		errorPlacement: function(error, element) {
			error.appendTo($('.wwf-error-messages'));
		},
		submitHandler: function(form) {
			var amount = $('.wwf-input').val();
			if (amount) {
				// Redirect payment action to support.wwf.ch form
				window.location.href = "https://support.wwf.ch/de/checkout/570/12295?amount=" + amount;
			}
		}
	});


	// SVG Injector
	var svgs = document.querySelectorAll('.inject-svg'),
		injectorOptions = {
			evalScripts: false,
			pngFallback: 'images/', // fallback image folder path for IE8
			each: function (svg) {
				// Callback after each SVG is injected
				// console.log('SVG injected: ');
				// console.log(svg);
			}
		};

		// Trigger the injection
		SVGInjector(svgs, injectorOptions, function (totalSVGsInjected) {
			// Callback after all SVGs are injected
			//console.log('Total injected ' + totalSVGsInjected + ' SVG(s)!');
		});

});

